import { render, staticRenderFns } from "./update-login-password.vue?vue&type=template&id=10c37d42&scoped=true"
import script from "./update-login-password.vue?vue&type=script&lang=js"
export * from "./update-login-password.vue?vue&type=script&lang=js"
import style0 from "./update-login-password.vue?vue&type=style&index=0&id=10c37d42&prod&scoped=true&lang=stylus"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "10c37d42",
  null
  
)

export default component.exports